export const CircledCheck = ({ className }: { className?: string }) => {
  return (
    <svg
      width="72"
      height="73"
      viewBox="0 0 72 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_18849_20056)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36 72.5C55.8823 72.5 72 56.3823 72 36.5C72 16.6177 55.8823 0.5 36 0.5C16.1177 0.5 0 16.6177 0 36.5C0 56.3823 16.1177 72.5 36 72.5ZM54.12 26.0615C54.9823 25.1668 54.9562 23.7424 54.0615 22.88C53.1668 22.0177 51.7424 22.0438 50.88 22.9385L29.3621 45.2621L21.116 36.7505C20.2514 35.858 18.8269 35.8354 17.9344 36.7001C17.0419 37.5647 17.0194 38.9892 17.884 39.8816L27.7502 50.0656C28.1747 50.5038 28.759 50.7508 29.3691 50.75C29.9792 50.7492 30.5628 50.5007 30.9862 50.0615L54.12 26.0615Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_18849_20056">
          <rect
            width="72"
            height="72"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
